export const getGitHubStats = async () => {
   const url = "https://api.github.com/users/j-puls";

   const requestData = {
      method: "GET",
      mode: "cors",
      cache: "force-cache",
      headers: {
         "Content-Type": "application/json",
         Authorization: process.env.REACT_APP_GITHUB_API_KEY
      },
      referrerPolicy: "no-referrer"
   };

   const data = fetch(url, requestData)
      .then((res) => res.json())
      .then((data) => data.public_repos)
      .catch((e) => console.log(e));
   return await data;
};

export default getGitHubStats;
